module.exports = new __parcel__URL__("Mkt Plan.cf8b450c.svg").toString();